import HoldCard from "./holdCard";
export default HoldCard;